export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const app_logo = require('../assets/image_logo.png');
export const background = require('../assets/backimage_.png');
export const imgviewa = require('../assets/view_B.png');
export const imgviewb = require('../assets/view_A.png');
export const VisibilityOff = require('../assets/visibility_off.png');